import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step__basic" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите начало адреса", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите продолжение адреса", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: Ленина, реки Фонтанки", -1)
const _hoisted_6 = { class: "input__groups" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Номер дома", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: 132", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Корпус", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: 1, отсутствует, другое", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Литера или строение", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: литера А, стр 2; стр 15; -", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите пересечение с домом или павильон, если имеется", -1)
const _hoisted_14 = { class: "right" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите район", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.begin_address_title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.begin_address_title) = $event)),
          editable: "",
          options: _ctx.begin_address_options,
          optionLabel: "name",
          placeholder: _ctx.begin_address_default.name,
          style: {"width":"480px"},
          onChange: _ctx.begin_address_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "Введите продолжение адреса",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.map_address) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.map_address]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _hoisted_7,
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.map_house) = $event)),
            maxlength: "10"
          }, null, 512), [
            [_vModelText, _ctx.document.map_house]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            placeholder: "1",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.map_korpus) = $event))
          }, null, 512), [
            [_vModelText, _ctx.document.map_korpus]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            placeholder: "0",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.map_build_litera) = $event))
          }, null, 512), [
            [_vModelText, _ctx.document.map_build_litera]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "Павильон, пересечение с домом Ленина, д.23",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.document.map_cross) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.map_cross]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", null, [
        _hoisted_15,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.region_title,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.region_title) = $event)),
          editable: "",
          options: _ctx.region_options,
          optionLabel: "name",
          placeholder: _ctx.region_default.name,
          style: {"width":"480px"},
          onChange: _ctx.region_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
      ])
    ])
  ]))
}